import { CategoricalStrategy } from "../../../../lib/layers/selectable/color/strategies";
export class KellyStrategy extends CategoricalStrategy {
    constructor() {
        super();
        this.name = 'Kelly';
    }
    visible_inputs() {
        let inputs = [
            'colorize-field',
            'colorize-gradient',
            'colorize-strategy',
            'colorize-opacity'
        ];
        return inputs;
    }
    colors() {
        return [
            "#FFB300", "#803E75", "#FF6800", "#A6BDD7", "#C10020", "#CEA262", "#817066",
            "#007D34", "#F6768E", "#00538A", "#FF7A5C", "#53377A", "#FF8E00", "#B32851",
            "#F4C800", "#7F180D", "#93AA00", "#593315", "#F13A13", "#232C16"
        ];
    }
    generate_colors(color_range) {
        const choices = this.colors();
        let colors = [];
        for (let i = 0; i < choices.length; i++) {
            colors.push(choices[i]);
        }
        color_range.update_jenks(colors);
        return colors;
    }
}
